/**
 * Card — Container element
 *
 * Variants:
 *   - variant: elevated (shadow), outlined (border), flat (no decoration)
 *   - padded: true/false
 */
import { styled, YStack, type GetProps } from 'tamagui'

const CardFrame = styled(YStack, {
  name: 'Card',
  bg: '$backgroundCard',
  br: '$lg',
  p: '$md',
  overflow: 'hidden',

  variants: {
    variant: {
      elevated: {
        elevationAndroid: 2,
        // Web shadow handled via Tamagui's shadow props
        shadowColor: '$shadowColor',
        shadowOffset: { width: 0, height: 1 },
        shadowOpacity: 0.06,
        shadowRadius: 4,
      },
      outlined: {
        bw: 2,
        bc: '$borderColor',
      },
      flat: {},
    },

    padded: {
      true: { p: '$md' },
      false: { p: 0 },
    },

    pressable: {
      true: {
        cursor: 'pointer',
        pressStyle: { opacity: 0.75, scale: 0.98 },
        hoverStyle: { opacity: 0.85 },
      },
    },
  } as const,

  defaultVariants: {
    variant: 'elevated',
    padded: true,
  },
})

export const Card = CardFrame.styleable((props, ref) => (
  <CardFrame
    ref={ref}
    transition="quick"
    animateOnly={['opacity', 'transform', 'background-color']}
    {...props}
  />
))
